import Link from 'next/link';
import { ReactNode } from 'react';

interface CardWrapperProps {
  children: ReactNode;
  href?: string;
}

export function CardWrapper({ children, href }: CardWrapperProps) {
  if (href)
    return (
      <Link href={href} className="block">
        {children}
      </Link>
    );
  return <>{children}</>;
}
